import _ from 'lodash';
import apiFetch, { defaultApiFetchErrorHandler } from 'react-scale/lib/api-fetch';
import { GridColumnVisibilityModel, GridColumns } from '@mui/x-data-grid-pro';
import {
  CustomColumn,
  IMandatoryColumn,
  IColorColumn,
} from '@scale/shared/types/corp/speedAuditColumnConfig';

export const saveColumnConfig = async (
  projectId: string,
  columnConfig: GridColumns,
  visibilityConfig: GridColumnVisibilityModel,
  mandatoryColumns: IMandatoryColumn,
  colorColumns: IColorColumn,
  admin?: boolean,
) => {
  try {
    await apiFetch(null, `corp-api/attemptAudit/speedAuditColumnConfig`, {
      method: 'POST',
      body: {
        projectId,
        columnConfig,
        visibilityConfig,
        mandatoryColumns,
        colorColumns,
        admin,
      },
    });
  } catch (err) {
    defaultApiFetchErrorHandler(err, { handleHttp: true });
  }
};

export const getColumnConfig = async (projectId: string) => {
  try {
    const colConfig = await apiFetch(
      null,
      `corp-api/attemptAudit/speedAuditColumnConfig?projectId=${projectId}`,
      {
        method: 'GET',
      },
    );
    return colConfig;
  } catch (err) {
    defaultApiFetchErrorHandler(err, { handleHttp: true });
    return {};
  }
};

export const applyColumnConfig = (columns: GridColumns, colConfig: any) => {
  if (columns && columns.length && colConfig && colConfig.columnConfig) {
    const newColumns = _.cloneDeep(columns);
    for (const [targetIndex, col] of colConfig.columnConfig.entries()) {
      const oldIndex = newColumns.findIndex(c => c.field === col.field);
      if (oldIndex >= 0) {
        newColumns[oldIndex].width = col.width;
        const element = newColumns[oldIndex];
        newColumns.splice(oldIndex, 1);
        newColumns.splice(targetIndex, 0, element);
      }
    }
    return newColumns;
  } else {
    return columns;
  }
};

export const isProjectAdmin = async (projectId: string): Promise<boolean> => {
  try {
    const { isAdmin } = await apiFetch(
      null,
      `corp-api/attemptAudit/speedAuditColumnConfig/isAdmin`,
      {
        method: 'GET',
        query: {
          projectId,
        },
      },
    );
    return isAdmin;
  } catch (err) {
    defaultApiFetchErrorHandler(err, { handleHttp: true });
    return false;
  }
};

export const getCustomColumnConfigs = async (
  projectId: string,
): Promise<{
  editableCustomColumns: CustomColumn[];
  customFormulaColumns: CustomColumn[];
  fixedCustomColumnsQuery: string;
}> => {
  try {
    const customColumns = await apiFetch(
      null,
      `corp-api/attemptAudit/speedAuditColumnConfig/customColumns`,
      {
        method: 'GET',
        query: {
          projectId,
        },
      },
    );
    return customColumns;
  } catch (err) {
    defaultApiFetchErrorHandler(err, { handleHttp: true });
    return { editableCustomColumns: [], customFormulaColumns: [], fixedCustomColumnsQuery: '' };
  }
};

export const setCustomColumnConfigs = async (
  projectId: string,
  editableCustomColumns: CustomColumn[],
  customFormulaColumns: CustomColumn[],
  fixedCustomColumnsQuery: string,
) => {
  try {
    await apiFetch(null, `corp-api/attemptAudit/speedAuditColumnConfig/customColumns`, {
      method: 'POST',
      body: {
        projectId,
        editableCustomColumns,
        customFormulaColumns,
        fixedCustomColumnsQuery,
      },
    });
    return true;
  } catch (err) {
    return false;
  }
};
